import type { HTMLAttributes } from 'react';
import { cn } from '@helpers/cn';

export const FlexCellContent = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('table-cell-content m-0 flex items-center md:min-h-[88px]', className)} {...props} />
);
